// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"199":"8bc29bd4f8ec9bb2d9e6","225":"4b69d3e9b4f0dc604a36","520":"9eb6978184e9248756a0","585":"e3bfa970f4f1904413bc","666":"fb57354191ab3abedbfb","837":"faf8b9e6f2b9cda4a9ca","955":"cbc21b600d54e21edc12"}[chunkId] + ".bundle.js";
};